import React from 'react';
import ChevronDown from '../assets/images/chevron-down.svg';

export default () => {
  return (
    <div>
      <img src={ChevronDown} alt="expand-row-icon" />
    </div>
  );
};
